import orderBy from 'lodash-es/orderBy';
import { IState } from '..';
import { ICartLine } from './cartsInterfaces';

export function getCartQuantity(
  state: IState,
  itemId: string,
  inventColorId: string | undefined | null,
  cartId: number
): number {
  return getActiveCartLines(state, cartId)
    .filter(x => !x.removed && x.itemId === itemId && (!inventColorId || x.inventColorId === inventColorId))
    .reduce((sum, line) => (sum += line.quantity), 0);
}

export function getCartLineKey(line: { cartId: number; itemId: string; inventColorId?: string | null }): string {
  return `${line.cartId}_${line.itemId}_${line.inventColorId}`;
}

export function isCartItemSaving(
  state: IState,
  line: { cartId: number; itemId: string; inventColorId?: string | null }
): boolean {
  const key = getCartLineKey(line);
  return state.carts.savingCartLines.includes(key);
}

export function getCartTotal(state: IState, cartId: number): number {
  return getActiveCartLines(state, cartId).reduce((sum, line) => (sum += line.quantity * line.price), 0);
}

export function getActiveCartLines(state: IState, cartId: number): ICartLine[] {
  const { cartLines, carts } = state.carts;
  let lines: ICartLine[] = [];

  if (carts[cartId]) {
    lines = carts[cartId].cartLines.map(x => cartLines[x]).filter(x => x && !x.removed);
  }

  return orderBy(lines, (l: ICartLine) => l.itemId);
}
